<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div :key="keyValue">
		<egranty-section-divider
			text="Obszary (priorytety), których dotyczy wniosek"
			icon="place"
		></egranty-section-divider>
		<br>
		<v-autocomplete
			class="ma-3 ml-4"
			:disabled="readonly"
			v-model="mainCountryName"
			:items="countries"
			no-data-text="Placówka nie jest akredytowana na żaden kraj z tego naboru"
			item-text="name"
			item-value="name"
			label="Główny kraj"
			aria-label="main country name"
			for="agency-priority-tree-change-main-country"
			id="agency-priority-tree-change-main-country"
			@input="updateTree"
		></v-autocomplete>
		<div v-if="treeLoaded===false && mainCountryName" class="ml-4">
			<offer-button
				v-if="!readonly"
				text="Edytuj wybór priorytetów"
				icon="edit"
				@click="startEdit(mainCountryName)"
			></offer-button>
		</div>
		<div>
			<v-treeview
				class="ma-3 ml-4 mb-5"
				v-if="treeLoaded===true"
				:key="keyValue"
				v-model="tree"
				:active.sync="active"
				:items="tasks"
				:open-all="true"
				selectable
				:open.sync="open"
				item-key="uniqueName"
				:return-object=true
			>
				<template v-slot:prepend="{ item }">
					<v-icon> label</v-icon>
				</template>
			</v-treeview>
		</div>
		<div
			style="padding: 3px"
			v-for="(optionsList, indexList) in priorityOptions"
			v-bind:key="indexList"
			class="agency-priority-tree-outer"
		>
			<h2 v-if="optionsList !== undefined">Priorytet:
				{{optionsList.name}}</h2>
			<div
				class="agency-priority-tree"
				v-if="optionsList !== undefined"
				style="padding-left: 40px"
			>
				<v-select
					:disabled="readonly"
					:key="keyValue"
					v-if="data.selected[indexList] !== undefined && optionsList.options.length !== 0"
					v-model="data.selected[indexList].areas"
					:items="optionsList.options"
					multiple
					item-text="name"
					item-value="id"
					label="Obszary"
					aria-label="areas"
					for="agency-priority-tree-area-application"
					id="agency-priority-tree-area-application"
				></v-select>
			</div>
		</div>

		<v-autocomplete
			class="ml-3"
			v-if="mainCountryName && manyAccreditationCountries && extraCountries.length >= 1"
			:disabled="readonly"
			v-model="data.extraCountries"
			:items="extraCountries"
			multiple
			item-text="name"
			item-value="id"
			label="Dodatkowe kraje"
			aria-label="extra countries"
			for="agency-priority-tree-extra-countries"
			id="agency-priority-tree-extra-countries"
			@input="extraCountriesChanged"
		></v-autocomplete>
		<br>
		<egranty-validation-error
			:error="error"
		></egranty-validation-error>
	</div>

</template>

<script>
	import {AgencyTask} from "../../../../api/generated/AgencyTask";
	import {AgencyTaskAccreditationCountry} from "../../../../api/generated/AgencyTaskAccreditationCountry";
	import OfferButton from "../../offer/components/OfferButton";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";

	export default {
		name: "AgencyPriorityTree",
		components: {EgrantyValidationError, EgrantySectionDivider, OfferButton},

		computed: {},
		methods: {


			validate() {
				if (this.data.mainCountryId === '' || this.data.mainCountryId === null && this.countries.length > 0) {
					this.error = "Proszę wybrać kraj, na który składana jest oferta";
					return false;
				}
				if (this.data.mainCountryId === '' || this.data.mainCountryId === null && this.countries.length === 0) {
					this.error = "Placówka nie jest akredytowana na żaden kraj z tego naboru. Złożenie wniosku jest niemożliwe.";
					return false;
				}
				if (this.data.selected.length === 0) {
					this.error = "Proszę wybrać co najmniej jeden priorytet, którego dotyczy oferta";
					return false;
				}
				if (!this.manyPriorities && this.data.selected.length > 1) {
					this.error = "Proszę wybrać nie więcej niż jeden priorytet";
					return false;
				}

				if (!this.manyTasks) {
					let task = "";
					for (var treeItem in this.tree) {
						if (treeItem.type === 'priority') {
							if (task === '') {
								task = treeItem.taskName;
							}
							if (task !== treeItem.taskName) {
								this.error = "Proszę wybrać nie więcej niż jedno zadanie";
								return false;
							}
						}
					}
				}

				if (!this.manyAreas) {
					let totalAreasCount = 0;
					for (let priority of this.data.selected) {
						totalAreasCount += priority.areas.length;
					}
					if (totalAreasCount > 1) {
						this.error = "Proszę wybrać nie więcej niż jeden obszar";
						return false;
					}
				}

				return true;
			},


			getContestId() {
				return this.$route.params.id;
			},

			startEdit() {
				this.data.selected = [];
				this.priorityOptions = [];
				this.tasks = this.tasksForPriorities.sort(function(a, b) {
          return a.orderId - b.orderId;
        });
				this.keyValue++;
				this.treeLoaded = true;
			},

			updateTree(val) {
				this.treeLoaded = true;
				this.data.mainCountryId = this.countries.find(x => x.name === val).id;
				this.loadTasks(val, true);
				this.updateExtraCountries(val);
				this.$emit("countriesChanged");
				this.$emit("input", this.data);
			},

			updateExtraCountries(val) {
				this.data.extraCountries = [];
				this.extraCountries = this.countries.filter(x => x.name !== val);
			},

			loadAreas(priority) {
				AgencyTask.getAreas(this, priority.id, response => {
						this.$set(priority, "areas", response);
						for (let e = 0; e < response.length; e++) {
							let area = response[e];
							this.$set(area, "type", "area");
							this.$set(area, "uniqueName", area.id + area.type);
						}
					},
				);
			},

			loadPriorities(task, country) {
				AgencyTask.getPriorities(this, country.id, (response) => {
						if (task.children === undefined) {
							this.$set(task, "children", []);
						}
						task.children = task.children.concat(response);
						for (let w = 0; w < response.length; w++) {
							let priority = response[w];
							this.$set(priority, "taskName", task.name);
							this.$set(priority, "countryName", country.name);
							this.$set(priority, "type", "priority");
							this.$set(priority, "uniqueName", priority.id + priority.type);
							this.loadAreas(priority);
						}
						this.left--;
						if (this.left === 0) {
							this.keyValue++;
							this.updatePriorityOptions();
						}
					});
			},

			loadCountries(task, requiredCountry) {
				AgencyTask.getTaskAccreditationCountries(this, task.id, (response) => {
					response = response.filter(country => country.name === requiredCountry);
					this.left += response.length;
					for (let q = 0; q < response.length; q++) {
						let country = response[q];

						this.$set(country, "type", "country");
						this.$set(country, "taskName", task.name);
						this.$set(country, "uniqueName", country.id + country.type);
						this.loadPriorities(task, country);
					}
					this.left--;
					if (this.left === 0) {
						this.keyValue++;
						this.updatePriorityOptions();
					}
				});
			},

			extraCountriesChanged() {
				this.$emit("countriesChanged");
				this.$emit("input", this.data);
			},

			loadTasks(requiredCountry, loadForTree) {
				this.left++;
				AgencyTask.getCountryTasks(this, this.getContestId(), this.data.mainCountryId, (response) => {

					this.left += response.length;
					for (let i = 0; i < response.length; i++) {
						let task = response[i];
						this.$set(task, "type", "task");
						this.$set(task, "uniqueName", task.id + task.type);
						this.loadCountries(task, requiredCountry);
					}

					this.tasksForPriorities = response;
					if (loadForTree === true) {
						this.tasks = response.sort(function(a, b) {
              return a.orderId - b.orderId;
            });
					}

					this.left--;
					if (this.left === 0) {
						this.keyValue++;
						this.updatePriorityOptions();
					}

				});
			},

			updatePriorityOptions() {
				this.priorityOptions = [];
				this.priorityOptions.length = this.selected.length;
				for (let i = 0; i < this.tasksForPriorities.length; i++) {
					if (this.tasksForPriorities[i].children === undefined) {
						continue;
					}
					for (let q = 0; q < this.tasksForPriorities[i].children.length; q++) {
						let val = this.tasksForPriorities[i].children[q];
						if (this.selected.find(x => x.id === val.id)) {
							let index = this.selected.findIndex(x => x.id === val.id);
							AgencyTask.getAreas(this, val.id, response => {
									this.$set(this.priorityOptions, index, {
										name: val.name,
										id: val.id,
										options: response,
									});
									this.keyValue++;
								});
						}
					}
				}
			},

			refresh() {
				if (this.agencyId === undefined) {
					return;
				}
				AgencyTaskAccreditationCountry.getAvailableCountriesForAgency(
					this,
					this.getContestId(),
					this.agencyId,
					response => {
						this.countries = response;
						this.extraCountries = response;
						if (this.dataFromServerLoaded) {
							this.setMainCountryName();
						}
						if (this.data.mainCountryId !== null) this.loadTasks(this.mainCountryName, false);
					},
				);
			},

			setMainCountryName() {
				if (this.data.mainCountryId !== null) {
					let country = this.countries.find(x => x.id === this.data.mainCountryId);
					this.mainCountryName = country !== undefined ? country.name : undefined;
					this.extraCountries = this.countries.filter(x => x.name !== this.mainCountryName);
				}
			},
		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					if (val === undefined) {
						return;
					}
					this.active = val.selected;
					this.data = val;
					this.selected = val.selected;
					this.setMainCountryName();
					if (this.data.mainCountryId !== null) this.loadTasks(this.mainCountryName, false);
					if (this.dataFromServerLoaded === false) {
						this.refresh();
					}
					this.dataFromServerLoaded = true;
				},
			},

			tree: {
				handler(val) {
					this.data.selected = this.data.selected.filter(x => val.find(y => y.type === 'priority' && y.id === x.id));
					this.priorityOptions = [];
					for (let i = 0; i < val.length; i++) {
						if (val[i].type !== "priority") {
							continue;
						}
						if (!this.data.selected.find(x => x.id === val[i].id)) {
							this.data.selected.push({id: val[i].id, areas: []});
						}
						this.priorityOptions.push({name: val[i].name, id: val[i].id, options: val[i].areas});

					}
					//this.updatePriorityOptions();
					this.$emit("input", this.data);
				},
			},
		},

		data() {
			return {
				error: '',
				dataFromServerLoaded: false,
				treeLoaded: false,
				tree: [],
				activeTree: [],
				tasks: [],
				tasksForPriorities: [],
				selected: [],
				open: [],
				keyValue: 0,
				active: [],
				left: 0,
				countries: [],
				extraCountries: [],
				data: {
					mainCountryId: null,
					selected: [],
					extraCountries: [],
				},
				priorityOptions: [],
				mainCountryName: "",
			};
		},
		mounted() {
			this.refresh();
		},

		props: {
			value: {
				type: Object,

			},
			readonly: {type: Boolean, default: false},
			manyAccreditationCountries: {type: Boolean, default: false},
			manyTasks: {},
			manyPriorities: {},
			manyAreas: {},
			agencyId: Number,
		},
	};

</script>
